import { METRIC_DEFINITIONS } from '../constants/metrics';

const textColor = (isDark) => (isDark ? '#ffffff' : '#333333');

export const createBarChartOptions = ({
  title,
  categories,
  values,
  colors,
  isDark,
  rotateLabels = 0,
}) => ({
  title: {
    text: title,
    left: 'center',
    textStyle: {
      fontSize: 16,
      fontWeight: 'bold',
      color: textColor(isDark),
    },
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: { type: 'shadow' },
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    data: categories,
    axisLabel: {
      rotate: rotateLabels,
      color: textColor(isDark),
    },
  },
  yAxis: {
    type: 'value',
    max: 100,
    name: '',
    nameTextStyle: { color: textColor(isDark) },
    axisLabel: { color: textColor(isDark) },
  },
  series: [
    {
      name: title,
      type: 'bar',
      data: values.map((value, index) => ({
        value,
        itemStyle: { color: colors[index] || '#3bbddb' },
      })),
    },
  ],
});

export const createSingleTeamMetricCharts = (team, metrics, teamName, isDark) =>
  METRIC_DEFINITIONS.map(({ key, title }) =>
    createBarChartOptions({
      title,
      categories: [teamName],
      values: [metrics[key]],
      colors: [team.color || '#3bbddb'],
      isDark,
    })
  );

export const createMultiTeamMetricCharts = (teams, getMetrics, isDark) =>
  METRIC_DEFINITIONS.map(({ key, title }) => {
    const teamNames = teams.map((team) => team.name);
    const values = teams.map((team) => getMetrics(team)[key]);
    const colors = teams.map((team) => team.color || '#3bbddb');

    return createBarChartOptions({
      title,
      categories: teamNames,
      values,
      colors,
      isDark,
      rotateLabels: 45,
    });
  });

export const createRadarChartOptions = (team, metrics, isDark) => ({
  title: {
    text: 'Метрики команды',
    left: 'center',
    textStyle: { color: isDark ? '#e2e8f0' : '#333333' },
  },
  radar: {
    indicator: METRIC_DEFINITIONS.map(({ title }) => ({ name: title, max: 100 })),
    name: { textStyle: { color: isDark ? '#60a5fa' : '#333333' } },
    axisLine: { lineStyle: { color: isDark ? '#334155' : '#ddd' } },
    splitLine: { lineStyle: { color: isDark ? '#334155' : '#ddd' } },
  },
  series: [
    {
      type: 'radar',
      data: [
        {
          value: METRIC_DEFINITIONS.map(({ key }) => metrics[key]),
          name: team.name,
          areaStyle: { opacity: 0.3 },
          lineStyle: { width: 2 },
          itemStyle: { color: team.color || '#3bbddb' },
        },
      ],
    },
  ],
});

export const getMetricChartConfigs = (charts) =>
  METRIC_DEFINITIONS.map((definition, index) => ({
    ...definition,
    options: charts[index],
  }));
